var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-0 pa-0 bg-white rounded-lg"},[_c('iframe',{ref:"iframe",staticClass:"custom-content-height",staticStyle:{"width":"100% !important"},attrs:{"src":_vm.token,"frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }